import styled from "@emotion/styled";
import {mq} from "@styles/helpers";
import {Devices} from "@styles/tokens";

export const Content = styled.div`
    
`;

export const RewardContainer = styled.div`
    display:grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap:20px;
    margin-top: 30px;
    position: relative;
    min-height: 200px;

    ${mq(Devices.laptop)}{
        margin-top: 10px;
        grid-template-columns: 1fr 1fr 1fr;
    }

    ${mq(Devices.mobile)}{
        margin-top: 20px;
        grid-template-columns: 1fr 1fr;
    }
`;

export const PopRewardContainer = styled.div<{freeWidth?:boolean}>`
    max-height:${props => props.freeWidth?"calc(90vh - 120px)":"calc(70vh - 120px)"};
    width:100%;
    overflow-y: auto;
    scrollbar-gutter: stable;

    ${mq(Devices.tablet)}{
       height:calc(100vh - 220px);
    }
`;


export const PopReward = styled.div`
    display: grid;
    gap: 20px;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    > div{
        width:100%;
    }

     ${mq(Devices.mobile)}{
       grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
    }
`;